const localizers = {
  'Alerts.noAlerts.txt': () => `Er zijn geen meldingen ingesteld voor dit rapport.`,
  'BirdImage.image.txt': () => `Afbeelding`,
  'ComboBox.clearFilter.txt': () => `Filter wissen`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (geen gegevens)`,
  'ContextMenu.selectAll.txt': () => `Alles selecteren`,
  'ContextMenu.clearSelection.txt': () => `Selectie wissen`,
  'ContextMenu.exportImage.txt': () => `Exporteren als afbeelding`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: Oplopend`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: Aflopend`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: Oplopend toevoegen`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: Aflopend toevoegen`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `${role} verwijderen uit sortering`,
  'ContextMenu.removeSortLevel.txt': () => `Sorteerniveau verwijderen`,
  'ContextMenu.sort.txt': () => `Sorteren`,
  'ContextMenu.selectShortestPath.txt': () => `Kortste pad selecteren`,
  'ContextMenu.explain.txt': () => `Gegevens toelichten`,
  'ContextMenu.explainRole.txt': ({role}) => `${role} toelichten...`,
  'ContextMenu.manageColumns.txt': () => `Kolommen beheren`,
  'ContextMenu.includeMissingValues.txt': () => `Inclusief ontbrekende waarden`,
  'DrillableTooltip.drill.txt': () => `ZOOMEN`,
  'DrillableTooltip.tooltip.txt': () => `KNOPINFO`,
  'DrillableTooltip.links.txt': () => `KOPPELINGEN`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Paginakoppeling naar ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Rapportkoppeling naar ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Externe koppeling naar ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Niet beschikbaar`,
  'Breadcrumb.all.fmt': ({label}) => `Alle ${label}`,
  'BrowserCheck.title.txt': () => `WebGL-controle`,
  'BrowserCheck.msg.txt': () => `WebGL is uitgeschakeld of wordt niet ondersteund door uw browser.   \nKlik op OK om het rapport in de klassieke viewer weer te geven.`,
  'EmailUtil.subject.multiple.txt': () => `Rapporten ter controle`,
  'EmailUtil.tooLongEmail.txt': () => `De maximale e-maillengte is overschreden. Selecteer minder rapporten om te e-mailen.`,
  'HiddenSectionDialog.close.txt': () => `Sluiten`,
  'HiddenSectionDialog.export.txt': () => `Exporteren als PDF`,
  'InfoPanel.information.txt': () => `Informatie`,
  'InfoPanel.comments.txt': () => `Opmerkingen`,
  'InfoPanel.alerts.txt': () => `Meldingen`,
  'IncomingFilters.promptbars.txt': () => `Vraagbalken`,
  'Information.title.txt': () => `Titel`,
  'Information.name.txt': () => `Naam:`,
  'Information.description.txt': () => `Beschrijving:`,
  'Information.displayRules.txt': () => `Weergaveregels:`,
  'Information.graphLevel.txt': () => `Grafiekniveau`,
  'Information.reportLevel.txt': () => `Rapportniveau`,
  'Information.legend.txt': () => `Legenda`,
  'Information.incomingFilters.txt': () => `Inkomende filters:`,
  'Information.noIncomingFilters.txt': () => `Geen inkomende filters`,
  'Information.dataSourceFilters.txt': () => `Gegevensbronfilters:`,
  'Information.interactiveFilters.txt': () => `Interactieve filters:`,
  'MobileContainer.mobileBIMessage.txt': () => `Open SAS-rapporten op uw mobiele apparaat.`,
  'ObjectTypes.report.txt': () => `Rapport`,
  'ObjectTypes.Report.BI.txt': () => `SAS-rapport (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored Process Report`,
  'ObjectTypes.StoredProcess.txt': () => `Opgeslagen proces`,
  'MissingValues.label.txt': () => `(ontbrekende waarden)`,
  'PromptContainer.apply.txt': () => `OK`,
  'PromptContainer.cancel.txt': () => `Annuleren`,
  'PromptContainer.close.txt': () => `Sluiten`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Waarde moet een getal in het bereik van ${min} tot en met ${max} zijn.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Geef een geldige numerieke waarde op.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Waarde is niet geldig voor de toegewezen gegevens.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Invoer: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Invoer: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `${placeholderLabel} invoeren...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} - ${max}`,
  'Slider.missingValues.txt': () => `Ontbrekende waarden`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Terug`,
  'ReportContainer.reportCorrupted.txt': () => `RAPPORT BESCHADIGD`,
  'ReportContainer.themeLoadFailed.txt': () => `Rapportthema kan niet worden geladen.`,
  'ReportContainer.restoreButton.tip.txt': () => `Rapport herstellen`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Rapport hersteld`,
  'ReportContainer.renderError.txt': () => `Er is een fout opgetreden. Het rapport kan niet worden weergegeven.`,
  'ReportContainer.component.renderError.txt': () => `Er is een fout opgetreden. De component kan niet worden gerenderd.`,
  'ReportContentPage.open.txt': () => `Openen...`,
  'ReportContentPage.refreshReport.txt': () => `Rapport vernieuwen`,
  'ReportContentPage.editReport.txt': () => `Rapport wijzigen`,
  'ReportContentPage.print.txt': () => `Afdrukken...`,
  'ReportContentPage.email.txt': () => `E-mail...`,
  'ReportContentPage.export.txt': () => `Exporteren naar Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Rapporteigenschappen`,
  'ReportContentPage.shareReport.txt': () => `Rapport delen`,
  'ReportContentPage.enableOverlays.txt': () => `Object-overlays inschakelen`,
  'ReportContentPage.disableOverlays.txt': () => `Object-overlays uitschakelen`,
  'ReportContentPage.link.txt': () => `Koppeling...`,
  'ReportContentPage.settings.txt': () => `Instellingen...`,
  'ReportContentPage.editPlayback.txt': () => `Weergave wijzigen`,
  'ReportContentPage.playReport.txt': () => `Rapport afspelen`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Vraagfilters weergeven`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Vraagfilters verbergen`,
  'ReportContentPage.reportFilters.txt': () => `Rapportniveau`,
  'ReportContentPage.pageFilters.txt': () => `Paginaniveau`,
  'ReportContentPage.refreshRequired.txt': () => `Rapport moet worden vernieuwd`,
  'ReportContentPage.infoButton.tip.txt': () => `Informatievenster`,
  'ReportContentPage.backButton.tip.txt': () => `Alle rapporten weergeven`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Meer opties`,
  'ReportContentPage.itemGroupName.txt': () => `Rapporten`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Rapport maximaliseren`,
  'ReportContentPage.closeButton.txt': () => `Rapport sluiten`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Rapport is gemaximaliseerd`,
  'ReportContentPage.resetReportState.txt': () => `Standaardstatus van rapport herstellen`,
  'ReportContentPage.summary.txt': () => `Samenvatting weergeven`,
  'ReportManagerPage.objectMenu.open.txt': () => `Openen`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Wijzigen`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Samenvatting`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Eigenschappen`,
  'ReportManagerPage.objectMenu.email.txt': () => `E-mail...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Afdrukken`,
  'ReportManagerPage.browseReportsButton.txt': () => `Door rapporten bladeren`,
  'ReportManagerPage.newReportButton.txt': () => `Nieuw rapport`,
  'ReportManagerPage.emptyView.message.txt': () => `Er zijn geen rapporten gevonden.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Bladeren naar rapporten`,
  'ReportManagerPage.tableView.name.txt': () => `Naam`,
  'ReportManagerPage.tableView.author.txt': () => `Auteur`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Laatst gewijzigd`,
  'ReportManagerPage.openButton.tip.txt': () => `Rapport openen`,
  'ReportManagerPage.emailButton.tip.txt': () => `Rapport via e-mail versturen`,
  'ReportManagerPage.printButton.tip.txt': () => `Rapport afdrukken naar pdf`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Rapporteigenschappen`,
  'ReportObject.multipleReferences.error.txt': () => `Rapportobjecten kunnen niet in meerdere contexten worden gebruikt.`,
  'ReportObject.notFound.error.txt': () => `De objectnaam is niet gevonden in het opgegeven rapport.`,
  'ReportObject.invalidPage.error.txt': () => `De opgegeven pagina is ongeldig.`,
  'ReportPropertiesDialog.open.txt': () => `Openen`,
  'ReportPropertiesDialog.close.txt': () => `Sluiten`,
  'ReportPropertiesDialog.name.txt': () => `Naam:`,
  'ReportPropertiesDialog.description.txt': () => `Beschrijving:`,
  'ReportPropertiesDialog.keywords.txt': () => `Trefwoorden:`,
  'ReportPropertiesDialog.type.txt': () => `Type:`,
  'ReportPropertiesDialog.location.txt': () => `Locatie:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Gemaakt door:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Datum gemaakt:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Gewijzigd door:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Datum gewijzigd:`,
  'ReportSections.newPageButton.txt': () => `Nieuwe pagina`,
  'ReportSections.closeTab.tooltip.txt': () => `Pagina verwijderen`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `Menu ${label}`,
  'ReportSummaryDialog.title.txt': () => `Samenvatting`,
  'ReportSummaryDialog.open.txt': () => `Openen`,
  'ReportSummaryDialog.cancel.txt': () => `Annuleren`,
  'ReportSummaryDialog.close.txt': () => `Sluiten`,
  'ReportSummaryDialog.noSummary.txt': () => `Er is geen samenvatting beschikbaar.`,
  'ReportTileBody.modifiedBy.txt': () => `Gewijzigd door:`,
  'ReportTileBody.lastModified.txt': () => `Laatst gewijzigd:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Rapport vernieuwen`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Rapport automatisch vernieuwen`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Controleren op updates na dit aantal minuten:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Meldingen`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Selecteer de standaardmeldingen:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `E-mailberichten verzenden`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `SMS-berichten verzenden`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Beheerdersstandaard`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Thema’s`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Altijd rapportthema SAS High Contrast gebruiken`,
  'ViewerBusyDialog.openReport.txt': () => `Rapport openen...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Export voorbereiden...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Voorbereiden voor afdrukken...`,
  'PDFGeneration.printingReport.txt': () => `Rapport-pdf wordt gegenereerd. Het item wordt gedownload zodra het klaar is.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} op ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Selecteer een actie`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `U hebt het laagste niveau van de hiërarchie bereikt.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `U hebt het laagste niveau van alle hiërarchieën bereikt.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Inzoomen op ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Momentopname van ${a0} ${a1} op ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Afbeelding opslaan`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Object afdrukken...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Object delen...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Meer`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Menu Object voor ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Weergeven met SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `In-/uitzoomen`,
  'ZoomControl.button.zoomin.txt': () => `Inzoomen`,
  'ZoomControl.button.zoomout.txt': () => `Uitzoomen`,
  'ZoomControl.button.display.txt': () => `Zoomknoppen`,
  'ZoomControl.button.reset.txt': () => `Zoom herstellen`,
  'ExpandControl.button.expand.txt': () => `Weergave maximaliseren`,
  'ExpandControl.button.restore.txt': () => `Weergave herstellen`,
  'ExpandControl.button.expand.tip.txt': () => `Maximaliseren`,
  'ExpandControl.button.restore.tip.txt': () => `Herstellen`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Paginakoppelingen kunnen niet worden uitgevoerd wanneer dit object is gemaximaliseerd.`,
  'DragModeControl.button.pan.tip.txt': () => `Pannen`,
  'DragModeControl.button.circular.tip.txt': () => `Ronde selectie`,
  'DragModeControl.button.freeform.tip.txt': () => `Vrije-vormselectie`,
  'DragModeControl.button.rectangular.tip.txt': () => `Rechthoekige selectie`,
  'DragModeControl.button.zoom.tip.txt': () => `In-/uitzoomen naar rechthoek`,
  'ReportXMLDialog.title.txt': () => `Rapport-XML`,
  'ReportXMLDialog.closeButton.txt': () => `Sluiten`,
  'ReportXMLDialog.copyButton.txt': () => `Naar klembord kopiëren`,
  'ReportXMLDialog.error.txt': () => `Fout bij laden van rapport-XML`,
  'ErrorDialog.error.txt': () => `Er is een fout opgetreden. Neem contact op met de systeembeheerder.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - Rapportviewer`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Rapport openen`,
  'OpenReportDialog.reports.txt': () => `Rapporten:`,
  'OpenReportDialog.cancel.txt': () => `Annuleren`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} objecten bijgewerkt`,
  'AriaLive.oneObjectUpdated.txt': () => `1 object bijgewerkt`,
  'AriaLive.reportOpened.txt': () => `Rapport geopend`,
  'AriaLive.reportClosed.txt': () => `Rapport gesloten`,
  'ExportData.generating.txt': () => `Export wordt gegenereerd. Het item wordt gedownload zodra het klaar is.`,
  'ExportData.warning.txt': () => `Fout bij genereren van gegevens`,
  'ExportData.nodata.txt': () => `Er zijn geen gegevens om te exporteren`,
  'ExportData.exportData.txt': () => `Gegevens exporteren...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Opslaan`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Annuleren`,
  'PlaybackAnimationDialog.playButton.txt': () => `Rapport afspelen`,
  'PlaybackAnimationDialog.title.txt': () => `Weergave wijzigen`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Transitie-eenheid:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Pagina`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Object`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Seconden per eenheid:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Gemaximaliseerde objecten weergeven:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Alleen canvas weergeven:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Timer weergeven:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Navigatie-elementen weergeven na klik of aanraking:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Vorige pagina`,
  'PlaybackNavigationControls.nextPage.txt': () => `Volgende pagina`,
  'PlaybackNavigationControls.previousObject.txt': () => `Vorig object`,
  'PlaybackNavigationControls.nextObject.txt': () => `Volgend object`,
  'TransportConnection.generateReportTimeout.txt': () => `Het duurt lang om het rapport te laden. Wilt u doorgaan?`,
  'TransportConnection.openReport.txt': () => `Rapport openen`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Het opgegeven rapport op de volgende locatie bestaat niet: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `${label} uitvouwen`,
  'Hierarchy.collapse.fmt': ({label}) => `${label} samenvouwen`,
  'GraphElementDecorator.overview.txt': () => `Overzicht`,
  'GraphElementDecorator.layers.txt': () => `Lagen verbergen of weergeven`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Overzicht verbergen`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Overzicht weergeven`,
  'TitleInfoButton.tooltip.txt': () => `Informatie`,
  'SectionSelectionBar.noSelections.txt': () => `Geen selecties`,
  'SectionSelectionBar.title.txt': () => `Filters:`,
  'CheckboxList.selectAll.txt': () => `Alles selecteren`,
  'CheckboxList.clearSelection.txt': () => `Selectie wissen`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Selectie wissen (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Toelichting op ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Toelichting wordt voorbereid...`,
  'ExplanationInfoDialog.cancel.txt': () => `Annuleren`,
  'ExplanationInfoDialog.close.txt': () => `Sluiten`,
  'PromptHeader.emptyReport.txt': () => `Sleep een gegevensitem of besturingselement hiernaartoe om een rapportprompt te maken.`,
  'PromptHeader.emptyPage.txt': () => `Sleep een gegevensitem of besturingselement hiernaartoe om een paginaprompt te maken.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Gebied met paginabesturingselementen samenvouwen`,
  'PromptHeader.expandPageControlArea.txt': () => `Gebied met paginabesturingselementen uitvouwen`,
  'PromptHeader.collapseReportControlArea.txt': () => `Gebied met rapportbesturingselementen samenvouwen`,
  'PromptHeader.expandReportControlArea.txt': () => `Gebied met rapportbesturingselementen uitvouwen`,
  'PromptHeader.collapseControlArea.txt': () => `Gebied met besturingselementen samenvouwen`,
  'PromptHeader.expandControlArea.txt': () => `Gebied met besturingselementen uitvouwen`,
  'PromptHeader.reportControlArea.txt': () => `Gebied met rapportbesturingselementen`,
  'PromptHeader.allControlAreas.txt': () => `Alle gebieden met besturingselementen`,
  'PromptHeader.pageControlArea.txt': () => `Gebied met paginabesturingselementen`,
  'ZeroState.editMode.txt': () => `Sleep een sjabloon, gegevensitems of objecten hiernaartoe.`,
  'ZeroState.viewMode.txt': () => `Er is geen inhoud om weer te geven.`,
  'ObjectStatus.assignData.txt': () => `Gegevens toewijzen`,
  'ObjectStatus.selectImage.txt': () => `Afbeelding selecteren`,
  'ObjectStatus.selectJob.txt': () => `Taak selecteren`,
  'ObjectStatus.cancelLoading.txt': () => `Laden annuleren`,
  'ObjectStatus.loadingCanceled.txt': () => `Laden geannuleerd`,
  'ObjectStatus.resumeLoading.txt': () => `Laden hervatten`,
  'ObjectStatus.refresh.txt': () => `Vernieuwen`,
  'ObjectStatus.setJobParameters.txt': () => `Parameterwaarden instellen`,
  'ObjectSearch.title.txt': () => `Geografisch zoeken`,
  'ObjectSearch.pin.txt': () => `Vastmaken`,
  'ObjectSearch.unpin.txt': () => `Losmaken`,
  'MainSearchPanel.searchHints.txt': () => `Zoektips`,
  'MainSearchPanel.searchResults.txt': () => `Zoekresultaten`,
  'MainSearchPanel.features.txt': () => `Functies`,
  'MainSearchPanel.pin.txt': () => `Nieuwe speld`,
  'MainSearchPanel.pin.tooltip.txt': () => `Nieuwe speld`,
  'MainSearchPanel.route.txt': () => `Nieuwe route`,
  'MainSearchPanel.route.tooltip.txt': () => `Nieuwe route`,
  'MainSearchPanel.geographicArea.txt': () => `Nieuw geogebied`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Nieuw geografisch gebied`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Mijn locatiespeld`,
  'MainSearchPanel.myLocationPin.txt': () => `Mijn locatie`,
  'MainSearchPanel.show.txt': () => `Weergeven`,
  'MainSearchPanel.show.all.txt': () => `Alles weergeven`,
  'MainSearchPanel.hide.txt': () => `Verbergen`,
  'MainSearchPanel.hide.all.txt': () => `Alles verbergen`,
  'MainSearchPanel.delete.txt': () => `Verwijderen`,
  'MainSearchPanel.delete.all.txt': () => `Alles verwijderen`,
  'MainSearchPanel.convert.txt': () => `Zoekresultaten omzetten in spelden`,
  'MainSearchPanel.convert.all.txt': () => `Alle zoekresultaten omzetten in spelden`,
  'MainSearchPanel.showPinLabels.txt': () => `Speldlabels weergeven`,
  'MainSearchPanel.close.label.txt': () => `Geografisch zoeken`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Details weergeven`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Demografische gegevens`,
  'PanelHeader.back.tooltip.txt': () => `Vorige`,
  'GeographicAreaPanel.title.txt': () => `Geografisch gebied`,
  'GeographicAreaPanel.draw.txt': () => `Gebied tekenen`,
  'GeographicAreaPanel.update.txt': () => `Gebied bijwerken`,
  'GeographicAreaPanel.label.txt': () => `Label:`,
  'GeographicAreaPanel.location.txt': () => `Locatie:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Afstand (mijl):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Afstand (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Afstand toevoegen`,
  'GeographicAreaPanel.time.add.txt': () => `Tijd toevoegen`,
  'GeographicAreaPanel.distance.delete.txt': () => `Afstand verwijderen`,
  'GeographicAreaPanel.time.minutes.txt': () => `Tijd (min.):`,
  'GeographicAreaPanel.duration.txt': () => `Duur:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Mijlen`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilometers`,
  'GeographicAreaPanel.menu.clear.txt': () => `Geografisch gebied wissen`,
  'GeographicAreaPanel.menu.link.txt': () => `Adres standaard aan gegevenselementen en spelden koppelen`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Adres van geografisch gebied loskoppelen`,
  'GeographicAreaPanel.menu.delete.txt': () => `Geografisch gebied verwijderen`,
  'GeographicAreaPanel.demographics.txt': () => `Demografische gegevens`,
  'GeographicAreaPanel.demographics.set.txt': () => `Demografische gegevens weergeven`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Weergave uitvouwen`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Demografische gegevens wijzigen`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Demografische gegevens verwijderen`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Demografische gegevens moeten opnieuw worden geladen`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Demografische gegevens opnieuw laden`,
  'GeographicAreaPanel.invalid.location.txt': () => `Het geografische gebied heeft geen geldige locatie en kan niet worden gemaakt.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Selecteer een dag en tijd`,
  'TravelTypeField.cancel.txt': () => `Annuleren`,
  'TravelTypeField.ok.txt': () => `OK`,
  'TravelTypeField.button.tooltip.txt': () => `Selecteer een dag en tijd`,
  'TravelTypeField.day.txt': () => `Dag:`,
  'TravelTypeField.time.txt': () => `Tijd:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Direct`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Afstand`,
  'TravelTypeField.travelType.txt': () => `Reistype:`,
  'TravelTypeField.traffic.txt': () => `Inclusief verkeer:`,
  'TravelTypeField.traffic.offset.txt': () => `Tijdverschuiving verkeer:`,
  'TravelTypeField.traffic.daytime.txt': () => `Dag en tijd verkeer:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Afstandseenheid`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Rijafstand`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Rijtijd`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Vervoersafstand`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Vervoerstijd`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Loopafstand`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Looptijd`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Nee`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Huidig verkeer`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Gangbaar verkeer`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} uur`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Verkeer bijwerken voor dit kenmerk`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Verkeer bijwerken voor alle kenmerken`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Verkeersgegevens bijwerken`,
  'RoutePanel.title.txt': () => `Route`,
  'RoutePanel.draw.txt': () => `Route tekenen`,
  'RoutePanel.update.txt': () => `Route bijwerken`,
  'RoutePanel.label.txt': () => `Label:`,
  'RoutePanel.locations.txt': () => `Locaties`,
  'RoutePanel.menu.clear.txt': () => `Route wissen`,
  'RoutePanel.menu.reverse.txt': () => `Route omkeren`,
  'RoutePanel.menu.add.waypoint.txt': () => `Routelocatie toevoegen`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Routelocatie verwijderen`,
  'RoutePanel.menu.unlink.txt': () => `Routelocatie loskoppelen`,
  'RoutePanel.menu.arrows.txt': () => `Routepijlen`,
  'RoutePanel.menu.arrows.hide.txt': () => `Routepijlen verbergen`,
  'RoutePanel.menu.arrows.show.txt': () => `Routepijlen weergeven`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Eén richting`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Twee richtingen`,
  'RoutePanel.menu.delete.txt': () => `Route verwijderen`,
  'RoutePanel.route.width.txt': () => `Routebreedte`,
  'RoutePanel.distance.txt': () => `Afstand:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} mijl`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Locatie toevoegen`,
  'RoutePanel.location.delete.txt': () => `Locatie verwijderen`,
  'RoutePanel.duration.txt': () => `Tijd:`,
  'RoutePanel.invalid.location.txt': () => `De route heeft geen geldige locaties en kan niet worden gemaakt.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Locatie ${index}, ${location}, invoer`,
  'PinPanel.pinTitle.txt': () => `Vastmaken`,
  'PinPanel.addDescription.txt': () => `Beschrijving toevoegen`,
  'PinPanel.deleteDescription.txt': () => `Beschrijving verwijderen`,
  'PinPanel.newPin.txt': () => `Nieuwe speld op deze locatie`,
  'PinPanel.deletePin.txt': () => `Speld verwijderen`,
  'PinPanel.linkPins.txt': () => `Spelden standaard aan gegevenselementen koppelen`,
  'PinPanel.unlinkAllItems.txt': () => `Alle items loskoppelen`,
  'PinPanel.unlinkItems.txt': () => `Items loskoppelen`,
  'PinPanel.label.txt': () => `Label:`,
  'PinPanel.location.txt': () => `Locatie:`,
  'PinPanel.description.txt': () => `Beschrijving:`,
  'PinPanel.linked.txt': () => `GEKOPPELD`,
  'PinPanel.searchClickPlaceholder.txt': () => `Zoeken of selecteren op de kaart`,
  'PinPanel.searchPlaceholder.txt': () => `Zoeken`,
  'PinPanel.addRoute.txt': () => `Route toevoegen`,
  'PinPanel.addRoute.tooltip.txt': () => `Route toevoegen`,
  'PinPanel.addArea.txt': () => `Nieuw geogebied toevoegen`,
  'PinPanel.addArea.tooltip.txt': () => `Geografisch gebied toevoegen`,
  'PinPanel.addArea.title.txt': () => `Geografisch gebied toevoegen`,
  'PinPanel.myLocationTitle.txt': () => `Mijn locatiespeld`,
  'PinPanel.deleteMyLocationPin.txt': () => `Mijn locatiespeld verwijderen`,
  'PinPanel.enableAutoUpdate.txt': () => `Automatisch bijwerken van Mijn locatie inschakelen`,
  'PinPanel.disableAutoUpdate.txt': () => `Automatisch bijwerken van Mijn locatie uitschakelen`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Interval voor automatisch vernieuwen van Mijn locatie wijzigen...`,
  'PinPanel.linkToPin.txt': () => `Koppelen aan speld`,
  'PinPanel.useCurrentLocation.txt': () => `Huidige locatie van speld gebruiken`,
  'PinPanel.notDrawn.txt': () => `Niet getekend`,
  'PinPanel.undetermined.txt': () => `Onbepaald`,
  'PinPanel.findMyLocation.txt': () => `Mijn locatie zoeken`,
  'PinPanel.cannotDetermineLocation.txt': () => `Uw huidige locatie kan niet worden bepaald. Raadpleeg de Help voor uw browser of apparaat als u uw locatie wilt delen.`,
  'PinPanel.autoRefreshInterval.txt': () => `Interval voor automatisch vernieuwen van Mijn locatie`,
  'PinPanel.interval.hours.txt': () => `Uur:`,
  'PinPanel.interval.minutes.txt': () => `Minuten:`,
  'PinPanel.interval.seconds.txt': () => `Seconden:`,
  'PinPanel.invalid.location.txt': () => `De speld heeft geen geldige locatie en kan niet worden gemaakt.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mijl`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} mijl`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} mijl`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min.`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} min.`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} min.`,
  'PinPanel.clearLocation.tooltip.txt': () => `Locatietekst wissen`,
  'DiscardChangesDialog.title.area.txt': () => `Geografisch gebied`,
  'DiscardChangesDialog.title.route.txt': () => `Route`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `U hebt wijzigingen aangebracht in het geografische gebied, maar het gebied niet opnieuw getekend.\n\nWilt u de wijzigingen in ${label} negeren?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `U hebt wijzigingen aangebracht in de geografische route, maar de route niet opnieuw getekend.\n\nWilt u de wijzigingen in ${label} negeren?`,
  'DiscardChangesDialog.discard.txt': () => `Negeren`,
  'DiscardChangesDialog.cancel.txt': () => `Annuleren`,
  'FeatureErrorDialog.title.area.txt': () => `Geografisch gebied tekenen`,
  'FeatureErrorDialog.title.route.txt': () => `Route tekenen`,
  'FeatureErrorDialog.text.area.txt': () => `Het geografische gebied kan niet worden getekend.\n\nTip: Als op de locatie van uw gebied geen infrastructuur (zoals wegen) aanwezig is, kan mogelijk geen geografisch gebied worden berekend. Gebruik in plaats daarvan een reistype “Afstand” of verplaats het gebied naar een locatie waar wel infrastructuur aanwezig is.`,
  'FeatureErrorDialog.text.route.txt': () => `De route kan niet worden getekend.\n\nTip: Als op de locatie van uw route geen infrastructuur (zoals wegen) aanwezig is, kan mogelijk geen route worden berekend. Gebruik in plaats daarvan een reistype “Afstand” of verplaats de route naar een locatie waar wel infrastructuur aanwezig is.`,
  'FeatureErrorDialog.close.txt': () => `Sluiten`,
  'DemographicsSelectorDialog.title.txt': () => `Demografische gegevens weergeven`,
  'DemographicsSelectorDialog.cancel.txt': () => `Annuleren`,
  'DemographicsSelectorDialog.ok.txt': () => `OK`,
  'DemographicsSelectorDialog.country.txt': () => `Land/regio`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Standaard`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Geavanceerd`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Recent`,
  'DemographicsSelectorDialog.categories.txt': () => `Categorieën`,
  'DemographicsSelectorDialog.category.income.txt': () => `Inkomen`,
  'DemographicsSelectorDialog.category.age.txt': () => `Leeftijd`,
  'DemographicsSelectorDialog.category.households.txt': () => `Huishoudens`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Huisvesting`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Huwelijkse staat`,
  'DemographicsSelectorDialog.category.population.txt': () => `Populatie`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Gebruikersgroep`,
  'DemographicsSelectorDialog.category.health.txt': () => `Gezondheid`,
  'DemographicsSelectorDialog.category.education.txt': () => `Opleiding`,
  'DemographicsSelectorDialog.category.business.txt': () => `Bedrijf`,
  'DemographicsSelectorDialog.category.race.txt': () => `Ras`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Uitgaven`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Gedragingen`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Functies`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Armoede`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Tapestry`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `Risico`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Kernfeiten`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Vraag en aanbod`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Beleid`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Landschap`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Criminaliteit`,
  'ManageColumns.title.txt': () => `Kolommen beheren`,
  'ManageColumns.ok.txt': () => `OK`,
  'ManageColumns.cancel.txt': () => `Annuleren`,
  'ManageColumns.hiddenColumns.txt': () => `Verborgen kolommen`,
  'ManageColumns.displayedColumns.txt': () => `Weergegeven kolommen`,
  'SearchResultPanel.title.txt': () => `Zoekresultaat`,
  'SearchResultPanel.menu.delete.txt': () => `Zoekresultaat verwijderen`,
  'SearchResultPanel.convert.txt': () => `Omzetten in speld`,
  'SearchResultPanel.convert.tooltip.txt': () => `Omzetten in speld`,
  'DemographicsResultsDialog.title.txt': () => `Demografische gegevens`,
  'DemographicsResultsDialog.cancel.txt': () => `Annuleren`,
  'DemographicsResultsDialog.close.txt': () => `Sluiten`,
  'DemographicsResultsDialog.edit.txt': () => `Wijzigen`,
  'DemographicsResultsDialog.layout.page.txt': () => `Carrouselweergave`,
  'DemographicsResultsDialog.layout.list.txt': () => `Eénkolomsweergave`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Tegelweergave`,
  'DemographicsResultsDialog.noData.txt': () => `Er zijn geen gegevens die overeenkomen met het huidige geografische gebied.`,
  'PinsAtSameLocationPanel.title.txt': () => `Spelden op dezelfde locatie`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `ZOEKRESULTATEN`,
  'PinsAtSameLocationPanel.pins.txt': () => `SPELDEN`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Alles weergeven`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Alles verbergen`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Alles verwijderen`,
  'PinsAtSameLocationPanel.show.txt': () => `Weergeven`,
  'PinsAtSameLocationPanel.hide.txt': () => `Verbergen`,
  'PinsAtSameLocationPanel.delete.txt': () => `Verwijderen`,
  'LocationPopover.pin.title.txt': () => `Speldlocatie`,
  'LocationPopover.area.title.txt': () => `Locatie van geografisch gebied`,
  'LocationPopover.route.title.txt': ({label}) => `Routelocatie ${label}`,
  'LocationPopover.name.txt': () => `Naam`,
  'LocationPopover.location.txt': () => `Locatie:`,
  'LocationPopover.ok.txt': () => `Locatie instellen`,
  'LocationPopover.cancel.txt': () => `Selectiemodus afsluiten`,
  'LocationPopover.hint.txt': () => `Klik nogmaals op de kaart om een andere locatie aan te geven.`,
  'TreeDualSelector.source.default.txt': () => `Beschikbare items`,
  'TreeDualSelector.target.default.txt': () => `Geselecteerde items`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} van ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Geen items`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filter`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Aangepast item`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} items toegevoegd`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} items verwijderd`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Alle items zijn toegevoegd`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Alle items zijn verwijderd`,
  'TreeDualSelector.afterAction.up.txt': () => `Omhoog verplaatst`,
  'TreeDualSelector.afterAction.down.txt': () => `Omlaag verplaatst`,
  'TreeDualSelector.afterAction.top.txt': () => `Naar boven verplaatst`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Naar onderen verplaatst`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Toevoegactie ongedaan gemaakt`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Verwijderactie ongedaan gemaakt`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `aangepast item toegevoegd`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} aangepast item geselecteerd`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} geselecteerd`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} geselecteerd`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Eén rij omhoog in ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Eén rij omlaag in ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Naar bovenkant van ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Naar onderkant van ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Item toevoegen aan ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Alles toevoegen aan ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Item verwijderen uit ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Alles verwijderen uit ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Toevoegen ongedaan maken voor ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Verwijderen ongedaan maken voor ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `${listLabel} filteren`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Verwijderen`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Aangepaste items die u hebt geselecteerd om te verwijderen, worden permanent verwijderd als u doorgaat.\n\n Wilt u doorgaan?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Alle items verwijderen`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `De aangepaste items in deze lijst worden permanent verwijderd als u doorgaat.\n\n Wilt u doorgaan?`,
  'LinkNavigator.backButton.label': () => `Terug`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Inkomende filters`,
  'LinkNavigator.reportLevel.label': () => `Rapportniveau`,
  'LinkNavigator.sectionLevel.label': () => `Paginaniveau`,
  'ReportSectionZeroState.heading.label': () => `Een rapport ontwerpen`,
  'ReportSectionZeroState.description.label': () => `Sleep objecten of gegevensitems naar de pagina of selecteer een optie hieronder.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Sleep objecten of gegevensitems naar de pagina of begin met een paginasjabloon.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Object genereren`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Selecteer een sjabloon`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Suggesties bekijken`,
  'PromptContainerTooltip.noSelections.txt': () => `Geen selecties`,
  'PromptContainerTooltip.selectedValues.txt': () => `Geselecteerde waarden`,
}
export default localizers;
